import { BodyText, Button, Heading } from '@postscript/components';
import MediaPreview from 'components/messagePreview/components/MediaPreview';
import styled from 'styled-components';
import { RcsMessageCard } from 'types/rcs';
import { isRcsMessageOpenLinkButton } from 'types/rcs/typeGuards';

const StyledCard = styled.div`
  background: var(--surface-bkg-color);
  border: 1px solid var(--border-color-dim);
  border-radius: var(--border-radius-medium);
  overflow: hidden;
`;

const StyledCardContent = styled.div`
  border-top: 1px solid var(--border-color-dim);
  padding: var(--spacing-2) var(--spacing-3);
`;

const StyledCardTitle = styled(Heading)`
  font-size: var(--font-size-small);
  margin-bottom: var(--spacing-1);
`;

interface StyledCardButtonProps {
  clickable: boolean;
}

const StyledCardButton = styled(Button)<StyledCardButtonProps>`
  border-radius: 0;
  border-top: 1px solid var(--border-color-dim);
  display: block;
  padding: var(--spacing-2) var(--spacing-3);
  pointer-events: ${({ clickable }) => (clickable ? 'auto' : 'none')};
  text-align: center;
  width: 100%;
`;

interface CardPreviewProps {
  card: RcsMessageCard;
}

const CardPreview = ({ card }: CardPreviewProps) => {
  return (
    <StyledCard>
      <MediaPreview
        mediaUrl={card.url}
        thumbnailUrl={card.thumbnailUrl}
        rounded={false}
      />
      <StyledCardContent>
        {card.title && (
          <StyledCardTitle size="xx-small">{card.title}</StyledCardTitle>
        )}
        <BodyText size="small">{card.text}</BodyText>
      </StyledCardContent>
      {card.buttons.map((button, index) => (
        <StyledCardButton
          clickable={isRcsMessageOpenLinkButton(button)}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          onClick={(e) => {
            e.stopPropagation();
            if (isRcsMessageOpenLinkButton(button))
              window.open(button.body.url, '_blank');
          }}
          size="small"
          variant="plain"
        >
          {button.body.text}
        </StyledCardButton>
      ))}
    </StyledCard>
  );
};

export default CardPreview;
